const ChatStyles = () => (
  <style jsx global>{`
    .input-group:focus-within {
        color: #212529;
        background-color: #fff;
        border-color: #86b7fe;
        box-shadow: 0 0 0 2px rgb(13 110 253 / 25%);
        z-index: 3;
        border-radius: 20px;
    }
    .input-group .form-control:focus {
        box-shadow: none !important;
    }
    .chat-window {
      bottom: 90px;
      left: 20px;
      width: 350px;
      height: 500px;
      border-radius: 10px;
      z-index: 1000;
      overflow: hidden;
    }
    `}
  </style>
);

export default ChatStyles;
